import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { api1 } from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../services/apiEndpoints";
import { login } from "../../redux/authSlice";
import useLightcastToken from "../../utils/useLightcastToken";

const useGoogleAuth = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useLightcastToken();

  const handleGoogleAuth = async ({
    credentialResponse,
    userType,
    setUser = () => {},
    setCurrentStep = () => {},
  }) => {
    try {
      const tokenId = credentialResponse.credential;

      const response = await api1.post(API_ENDPOINTS.GOOGLE_LOGIN, {
        tokenId,
        type: userType,
      });

      const user = response.data;

      // Store tokens and user info
      localStorage.setItem("authToken", user.token);
      localStorage.setItem("refreshToken", user.refreshToken);
      localStorage.setItem("userType", user.type);
      localStorage.setItem("firstName", user.firstName);
      localStorage.setItem("lastName", user.lastName);
      localStorage.setItem("email", user.email);
      window.dispatchEvent(new Event("accessTokenChanged"));

      dispatch(login(user));

      setUser({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
      });

      const isSubscribed = user.subscription?.isSubscribed;
      const isProfileComplete = user.isProfileComplete;
      const isWelcomeSeen = user.isWelcomeSeen;
      const isMentee = user.type === "user";

      if (!isSubscribed && isMentee) {
        localStorage.setItem("isFromGoogle", "true");
        navigate("/auth/signup", {
          state: { fromGoogle: true },
        });
        setTimeout(() => {
          setCurrentStep(2);
        }, 100);
      } else {
        let destination;
        if (!isProfileComplete) {
          destination = "/dashboard/profile";
        } else if (!isWelcomeSeen) {
          destination = "/dashboard/welcome";
        } else {
          destination = "/dashboard/home";
        }

        navigate(destination);
      }
    } catch (error) {
      console.error("Google login failed", error);
      toast.error("Google authentication failed");
    }
  };

  return { handleGoogleAuth };
};

export default useGoogleAuth;
